<template>
  <div>
    <div class="firstcom">
      <el-dialog
        @close="closePop"
        :visible.sync="PopupDatalist"
        title="直播提示"
        :close-on-click-modal="false"
      >
        <img
          src="../../../assets/live/liveback.png"
          alt=""
          class="img_downs"
          @click="PopupDatalist = false"
        />
        <div class="contents">
          <h1>中日大健康医疗线上论坛第5期</h1>
          <p>开播：3月10日18:00（星期四）北京时间：18:00-20:30</p>
          <p>东京时间：19：00-21:30</p>
          <div class="sign_up" @click="totarget">立即查看</div>
        </div>
      </el-dialog>
    </div>
    <!-- 初始提示弹窗 -->
    <div class="update_prompt">
      <el-dialog
        @close="closePop"
        :visible.sync="updateDatalist"
        title="温馨提示"
        :close-on-click-modal="false"
      >
        <div class="contents">
         
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import systemclass from "@/api/systemclassification";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
      PopupDatalist: true,
      isShowReport: false,
      updateDatalist:false, // 更新提示弹窗
    };
  },
  methods: {
    openReport() {
      this.isShowReport = true;
    },
    closePop() {
      //  let loginCode = JSON.parse(  //afsvgdsdf22sda1
      //   localStorage.getItem("userlist")
      // ).isKhyLoginIndex;
      // console.log(loginCode);//这里拿到0 判断一下
      // if(loginCode == 0){
      //   console.log('执行测试');
      //   this.$root.$setFirstLogin();
      //   this.$parent.reload()
      // }
    },
    Buriedpoint() {
      let parmas = {
        type: "3",
        code: "LivePopup",
        parent_code: "",
        stay_start_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
        stay_end_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
        stay_time: 1,
        ation_source: null,
        source: "khy",
        ip: null,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid
      };
      systemclass.addburied(parmas);
    },
    totarget() {
      this.PopupDatalist = false;
      let userod = JSON.parse(localStorage.getItem("userlist")).userID;
      this.Buriedpoint();
      this.$router.push({ path: `/LivePlayer?userId=${userod}` });
    }
  }
};
</script>

<style lang="scss" scoped>
.firstcom {
  &::v-deep .el-dialog {
    width: 30% !important;
  }
  ::v-deep .el-dialog__header {
    height: 55px;
    // line-height: 55px;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  .img_downs {
    width: 100%;
    height: 100%;
  }
  .contents {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .sign_up {
    margin-top: 20px;
    cursor: pointer;
    color: white;
    padding: 7px 40px;
    border-radius: 30px;
    background-color: #1890ff;
  }
}
.update_prompt{
  &::v-deep .el-dialog {
    width: 30% !important;
  }
  ::v-deep .el-dialog__header {
    height: 55px;
    // line-height: 55px;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
}
</style>
